declare const window: { $: any, credentials: any };

import { useEffect } from 'react'
import {
    Collapse, Box, IconButton, Grid
} from '@mui/material'
import { SidebarClose, SidebarOpen, RefreshCw} from 'lucide-react'
import { useState } from 'react'
import useWindowWidth from './../hooks/useWindowSize'
import HtmlPreviewer from './HtmlPreviewer'
import { usePreviewerContext } from '../context/PreviewerContextProvider'
import ChangePreviewUrlIconButton from './ChangePreviewUrlIconButton'

const CollapsablePreviewArea = (): JSX.Element => {
    const { preview } = usePreviewerContext()
    const windowWidth = useWindowWidth()

    const [panelWidth, setPanelWidth] = useState(407)
    useEffect(() => {
        // 433 + 863 (is the max size of the property editor, blocks and left menu).
        const widthFromTheLeftMenuBlocksAndPropertyEditor = 433 + 863 + 16;
        const minWidthFromPreviewPanel = 304
        const widthFromTheLeftMenuBlocksAndPropertyEditorAndPreviewPanel = widthFromTheLeftMenuBlocksAndPropertyEditor + minWidthFromPreviewPanel
        if (windowWidth > widthFromTheLeftMenuBlocksAndPropertyEditorAndPreviewPanel) {
            setPanelWidth(windowWidth - widthFromTheLeftMenuBlocksAndPropertyEditor)
        } else {
            setPanelWidth(304)
        }

        // This is a hack for the left navigation, it should collaps if the screen is to small
        if (preview.open && windowWidth < 1500) {
            window.$('#wrapper').addClass('small-tabs')
        } else if (!preview.open && windowWidth < 1200) {
            window.$('#wrapper').addClass('small-tabs')
        } else {
            window.$('#wrapper').removeClass('small-tabs')
        }

    }, [windowWidth])

    return (
        <Collapse
            orientation="horizontal"
            collapsedSize={64}
            in={preview.open}
            sx={{
                position: 'absolute',
                height: '100%',
                top: 0,
                bottom: 0,
                right: 0,
                boxShadow: 3,
            }}
        >
            <Box width={panelWidth + "px"} sx={{
                backgroundColor: '#fafafa',
                height: '100%'

            }}>
                <Box sx={{ width: '100%' }}>
                    <Box padding={1.5}>
                        <Grid container spacing={0} columns={16}>
                            <Grid item xs>
                                <IconButton
                                    id="toggle-preview"
                                    onClick={preview.toggle}
                                    sx={{
                                        borderRadius: 2,
                                    }}
                                >
                                    {preview.open ? <SidebarOpen /> : <SidebarClose />}
                                </IconButton>
                            </Grid>
                            <Grid item xs sx={{ textAlign: 'right' }}>
                                {(window.credentials && window.credentials.get('isAppEmployee')) ? <ChangePreviewUrlIconButton /> : null}
                                <IconButton
                                    id="toggle-preview"
                                    onClick={preview.reload}
                                    sx={{
                                        borderRadius: 2,
                                    }}
                                >
                                    <RefreshCw />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Box>
                    <HtmlPreviewer />
                </Box>
            </Box>
        </Collapse>
    )
}

export default CollapsablePreviewArea
